module.exports = __webpack_public_path__ + "../front/img/measure-width.170dc22b.jpg";